import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { getMembers, getMyGuild } from '../../store/reducers/Guild/guildRequest';
import { useAppDispatch, useAppSelector } from '../../store/reducers';
import MyGuildView from '../MyGuildView/MyGuildView';
import Loader from '../../components/Loader/Loader';
import { GuildActionsName } from '../../store/reducers/Guild/guildType';
import { setSocialStableNavigateBackRoute } from '../../store/reducers/Stable/slice';
import { useLocation } from 'react-router-dom';
const MyGuild = () => {
    const { guildInfo, members, pending, needUpdateGuild } = useAppSelector((state) => state.guild);
    const { activeWallet: { address, name } } = useAppSelector((state) => state.wallet);
    const pathname = useLocation();
    const dispatch = useAppDispatch();
    useEffect(() => {
        //Saving the initial route for later navigating
        dispatch(setSocialStableNavigateBackRoute(pathname));
    }, []);
    useEffect(() => {
        if (needUpdateGuild) {
            dispatch(getMyGuild());
        }
    }, [dispatch, needUpdateGuild, address, name]);
    useEffect(() => {
        dispatch(getMyGuild());
    }, [dispatch, address, name]);
    useEffect(() => {
        if (guildInfo) {
            dispatch(getMembers(guildInfo.id));
        }
    }, [dispatch, guildInfo]);
    return (_jsx(_Fragment, { children: pending.includes(GuildActionsName.GET_MY_GUILD) ? (_jsx(Loader, { preventScroll: true, className: "h-100vh" })) : (_jsx(MyGuildView, { guildInfoData: guildInfo, id: guildInfo === null || guildInfo === void 0 ? void 0 : guildInfo.id, myGuildView: true, memberList: members || [] })) }));
};
export default MyGuild;
